var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"app-menu"},_vm._l((_vm.navs),function(nav,navIndex){return _c('AppNavItem',_vm._b({key:navIndex},'AppNavItem',nav,false))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }